/**
 * Turn a Blob returned by the API into a browser file download.
 *
 * Extracts the pattern duplicated across the app (useCustomersCSV,
 * address-management-page, fleet-management-page, driver-management-page):
 * create an object URL, click a hidden anchor, then revoke the URL.
 */
export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  window.URL.revokeObjectURL(url);
};
